'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimeAtLoad = exports.getDomain = undefined;
exports.redirectToDomain = redirectToDomain;
exports.maybeRedirectToHubSpotDomain = maybeRedirectToHubSpotDomain;
exports.getAdminDomain = getAdminDomain;
exports.getLongDisplayName = getLongDisplayName;
exports.getIsRoundRobin = getIsRoundRobin;
exports.getLinkEditParam = getLinkEditParam;
exports.getHeaderType = getHeaderType;
exports.getHeaderOptions = getHeaderOptions;
exports.setDocumentTitle = setDocumentTitle;
exports.isWhitespace = isWhitespace;
exports.isEmpty = isEmpty;
exports.formatCustomFormFields = formatCustomFormFields;
exports.getRoundRobinUserIdToBook = getRoundRobinUserIdToBook;
exports.shouldIncludeDeleted = shouldIncludeDeleted;

var _Immutable = require('Immutable');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _once = require('transmute/once');

var _once2 = _interopRequireDefault(_once);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _formatName = require('I18n/utils/formatName');

var _formatName2 = _interopRequireDefault(_formatName);

var _TimeRangeListUtils = require('MeetingsBase/utils/TimeRangeListUtils');

var TimeRangeListUtils = _interopRequireWildcard(_TimeRangeListUtils);

var _TimeRange = require('MeetingsBase/models/TimeRange');

var _TimeRange2 = _interopRequireDefault(_TimeRange);

var _enums = require('MeetingsBase/constants/enums');

var _utils = require('MeetingsBase/utils/utils');

var _paths = require('MeetingsLib/constants/paths');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function redirectToDomain(domain) {
  window.location.host = domain;
}

function maybeRedirectToHubSpotDomain(domain) {
  if (domain === _paths.wrongHubSpotDomain) {
    redirectToDomain(_paths.hubSpotDomain);
  } else if (domain === _paths.wrongHubSpotQADomain) {
    redirectToDomain(_paths.hubSpotQADomain);
  }
}

var getDomain = exports.getDomain = function getDomain(email) {
  return email.replace(/.*@/, '');
};

function getAdminDomain() {
  return (0, _utils.isQA)() ? _paths.hubSpotQADomain : _paths.hubSpotDomain;
}

function getLongDisplayName(profile) {
  if (profile.firstName && profile.lastName) {
    return (0, _formatName2.default)({
      firstName: profile.firstName,
      lastName: profile.lastName
    });
  }
  return profile.fullName || profile.firstName || profile.name || profile.email;
}

function getIsRoundRobin(linkType) {
  return linkType === _enums.LINK_TYPES.get(_enums.MEETING_TYPES.ROUND_ROBIN);
}

function getLinkEditParam(linkType) {
  var isTeamLink = getIsRoundRobin(linkType) || linkType === _enums.LINK_TYPES.get(_enums.MEETING_TYPES.GROUP);

  return isTeamLink ? _enums.LINK_TYPE_PARAMS.get('team') : _enums.LINK_TYPE_PARAMS.get(_enums.MEETING_TYPES.PERSONAL);
}

function getHeaderType(isRoundRobin) {
  return isRoundRobin ? 'roundRobinHeader' : 'header';
}

function getHeaderOptions(isRoundRobin, companyName, profile) {
  return isRoundRobin ? { companyName: companyName || getDomain(profile.email) } : { fullName: getLongDisplayName(profile) };
}

function setDocumentTitle(headline, linkType, companyName, profile) {
  var isRoundRobin = getIsRoundRobin(linkType);
  var headerType = getHeaderType(isRoundRobin);
  var options = getHeaderOptions(isRoundRobin, companyName, profile);
  var profileHeader = _I18n2.default.text('prebook.' + headerType + '.online', options);
  document.title = headline || profileHeader;
}

function getRandomIndex(length) {
  return Math.floor(Math.random() * length);
}

function isWhitespace(value) {
  return typeof value === 'string' && value.trim().length <= 0;
}

function isEmpty(value) {
  return !value || value.trim() === '';
}

function formatCustomFormFields(formFields) {
  return formFields.reduce(function (acc, fieldAnswer, fieldName) {
    if (fieldAnswer === null) {
      // if unrequired field is left blank, don't send anything
      return acc;
    }

    var isDateField = fieldAnswer.year && fieldAnswer.month && fieldAnswer.date;
    var isListField = Array.isArray(fieldAnswer);

    if (isDateField) {
      fieldAnswer = _I18n2.default.moment.utc([fieldAnswer.year, fieldAnswer.month, fieldAnswer.date]).valueOf().toString();
    }

    if (isListField) {
      fieldAnswer = fieldAnswer.join(';');
    }

    return acc.push({ name: fieldName, value: fieldAnswer });
  }, (0, _Immutable.List)());
}

function getRoundRobinUserIdToBook(event, allUsersBusyTimes, bufferTime) {
  var dateTime = event.dateTime,
      duration = event.duration;

  var meeting = _TimeRange2.default.from({ start: dateTime, end: dateTime + duration });
  var onlineOffline = allUsersBusyTimes.map(function (userBusyTimes) {
    return userBusyTimes.update('busyTimes', function (busyTimes) {
      return TimeRangeListUtils.addBufferTime(busyTimes, bufferTime);
    });
  }).filter(function (paddedUserBusyTimes) {
    return paddedUserBusyTimes.get('busyTimes').every(function (paddedBusyTime) {
      return !paddedBusyTime.hasIntersection(meeting);
    });
  }).groupBy(function (availableUsers) {
    return availableUsers.get('offline');
  });

  var onlineBookableUsers = onlineOffline.get(false);
  var offlineBookableUsers = onlineOffline.get(true);
  if (onlineBookableUsers && onlineBookableUsers.size) {
    return onlineBookableUsers.get(getRandomIndex(onlineBookableUsers.size)).get('id');
  } else if (offlineBookableUsers && offlineBookableUsers.size) {
    return offlineBookableUsers.get(getRandomIndex(offlineBookableUsers.size)).get('id');
  }
  window.Raven.captureMessage('No users bookable on round robin link', {
    extra: {
      allUsersBusyTimes: allUsersBusyTimes,
      bufferTime: bufferTime,
      meeting: meeting
    }
  });
  return null;
}

function shouldIncludeDeleted(params) {
  return (0, _get2.default)('includeDeleted', params) || 'false';
}

var getTimeAtLoad = exports.getTimeAtLoad = (0, _once2.default)(function () {
  return _I18n2.default.moment().valueOf();
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/utils/utils.js
// module id = 27
// module chunks = 0